// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"5082079c","153":"e909bb6f","278":"17e1b068","289":"2259a141","305":"167bc61c","393":"26940a42","403":"9ba99cb6","536":"d7c7a191","558":"d8466356","561":"d62172df","572":"3a6b9d06","787":"13e3e0c6","822":"4d5075a3","916":"3c2b9e55"}[chunkId] + ".chunk.js";
};